export const statusAddOns = {
  20201: 'requested',
  20103: 'reimbursed',
  30201: 'awaiting_details',
  30202: 'pending_reimbursement',
};
